import {Component, Inject} from '@angular/core';
import {WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';

export class VideoViewerToolConfig implements WebmateToolConfig {
  toolName = "Video Viewer";

  constructor(public readonly videoUrl: string) {}
}

@Component({
  selector: "wm-video-viewer",
  templateUrl: "./video-viewer.component.html",
  styleUrls: ['./video-viewer.component.less']
})
export class VideoViewerComponent {

  constructor(@Inject(TOOL_CONTAINER_DATA) public data: VideoViewerToolConfig) {}

}
